const TimeZone = {
  getFriendlyTimeZone(): string {
    const now = new Date();
    const options: Intl.DateTimeFormatOptions = {
      timeZoneName: "long",
    };

    const formatter = new Intl.DateTimeFormat("en-US", options);
    const parts = formatter.formatToParts(now);
    const tzPart = parts.find((p) => p.type === "timeZoneName");

    return tzPart?.value || "Unknown Time Zone";
  },
};

export default TimeZone;

